import { definePreset } from '@primeng/themes'
import Aura from '@primeng/themes/aura'

const CustomPreset = definePreset(Aura, {
    primitive: {
        green: {
            50: '#f5f7f7',
            100: '#cddad8',
            200: '#a5bcb8',
            300: '#7d9f99',
            400: '#56817a',
            500: '#2e645b',
            600: '#27554d',
            700: '#204640',
            800: '#193732',
            900: '#122824',
            950: '#0c1917'
        },
        red: {
            50: '#fdf5f6',
            100: '#f7cfd2',
            200: '#f0a8af',
            300: '#e9828c',
            400: '#e35b68',
            500: '#dc3545',
            600: '#bb2d3b',
            700: '#9a2530',
            800: '#791d26',
            900: '#58151c',
            950: '#370d11'
        }
    },
    semantic: {
        primary: {
            50: '#f5f7f7',
            100: '#cddad8',
            200: '#a5bcb8',
            300: '#7d9f99',
            400: '#56817a',
            500: '#2e645b',
            600: '#27554d',
            700: '#204640',
            800: '#193732',
            900: '#122824',
            950: '#0c1917'
        }
    }
})

export default CustomPreset
